module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-to-right-064261f99b42d9ba9907e4cea27c0678.svg";